//https://ariakit.org/examples/combobox-radix

import {
	Combobox,
	ComboboxItem,
	ComboboxList,
	ComboboxProvider,
} from "@ariakit/react";

import {
	FieldSuggestionsValue,
	FieldSuggestions as HeadlessFieldSuggestions,
	StandaloneSearchBox,
} from "@coveo/headless";

import * as RadixPopover from "@radix-ui/react-popover";
import { FunctionComponent, useEffect, useRef, useState } from "react";

import { parseAutocompleteFieldValue } from "../../util/parse-autocomplete-field-value";
import { stripZipCode } from "../functions/strip-zip-code";

interface SearchBoxProps {
	fieldSuggestController: HeadlessFieldSuggestions;
	searchBoxController: StandaloneSearchBox;
	isHomepage: boolean;
}

const localStorageResultsKey = "results";

const currentLocText = "Current Location";

export const DrhSearchBox: FunctionComponent<SearchBoxProps> = (props) => {
	const [currentResultValues, setCurrentResultValues] = useState(() => {
		const value = localStorage.getItem(localStorageResultsKey);
		if (value !== null) {
			return JSON.parse(value);
		}
	});

	const { fieldSuggestController, searchBoxController, isHomepage } = props;
	const [suggestValues, setSuggestState] = useState(
		fieldSuggestController.state.values,
	);

	const [showCurrent, setShowCurrent] = useState(false);

	const [matchedValues, setMatchedValues] = useState([]);

	const [isHoverActive, setIsHoverActive] = useState<boolean>(true);

	useEffect(() => {
		const listenStorageChange = () => {
			setCurrentResultValues(() => {
				const value = localStorage.getItem(localStorageResultsKey);

				if (value !== null) {
					return JSON.parse(value);
				}
			});
		};
		window.addEventListener("storage", listenStorageChange);
		return () => window.removeEventListener("storage", listenStorageChange);
	}, []);

	function sortByCount(a, b) {
		if (a.count < b.count) {
			return 1;
		}
		if (a.count > b.count) {
			return -1;
		}
		return 0;
	}

	useEffect(
		() =>
			fieldSuggestController.subscribe(() => {
				if (fieldSuggestController.state.isLoading) {
					return;
				}

				var values = fieldSuggestController.state.values;

				//If there are no values and no more available it means nothing should be shown
				if (values.length === 0 && fieldSuggestController.state.query === "") {
					setOpen(false);
					return;
				}

				var isSearchPage = (window as any).IsSearchPage;

				//The search box on the homepage has different functionality, also if we are on a non CF search page
				if (isHomepage || !isSearchPage) {
					// 	// localStorage.removeItem(localStorageResultsKey);
					// 	// if (values.length === 0) {
					// 	// 	if (isZipValid(fieldSuggestController.state.query)) {
					// 	// 		values.push({
					// 	// 			count: 0,
					// 	// 			displayValue:
					// 	// 				"Search for Zip: " + fieldSuggestController.state.query,
					// 	// 			rawValue: fieldSuggestController.state.query,
					// 	// 		});
					// 	// 	}
					// 	// }
				}
				//The search box in the header
				else {
					if (isSearchPage && currentResultValues) {
						let newList = [];

						currentResultValues.forEach((result) => {
							let parsedResult = JSON.parse(result);

							//Do not do anything if the query is empty
							if (fieldSuggestController.state.query.trim() === "") {
								setMatchedValues([]);
							}
							//There is a query
							else {
								if (
									parsedResult.title
										.toLowerCase()
										.includes(fieldSuggestController.state.query.toLowerCase())
								) {
									newList.push(parsedResult);
								}

								setShowCurrent(true);
							}
						});

						setMatchedValues(newList);
					}
				}

				//Sort the values by count and then take the top 9 to display
				values.sort(sortByCount);
				if (!isSearchPage) {
					if (values.length !== 0) {
						values.unshift({
							count: 0,
							displayValue: currentLocText,
							rawValue: currentLocText,
						});
					}
				}

				if (values.length === 0) {
					setSuggestState([]);
				} else {
					setSuggestState(values.slice(0, 9));
					setOpen(true);
				}
			}),
		[currentResultValues],
	);

	useEffect(() => {
		if (matchedValues.length === 0) {
			setShowCurrent(false);
		}
	}, [matchedValues]);

	const comboboxRef = useRef<HTMLInputElement>(null);
	const listboxRef = useRef<HTMLDivElement>(null);

	const [open, setOpen] = useState(false);

	const onInput = (text: string) => {
		if (text === "") {
			fieldSuggestController.clear();
			return;
		}

		fieldSuggestController.updateText(text);
	};

	const onFocus = (text: string) => {
		if (text === "") {
			fieldSuggestController.clear();
			return;
		}

		fieldSuggestController.updateText(text);
		setIsHoverActive(true);
	};

	const handleMouseEnter = () => {
		setIsHoverActive(false);
	};

	const handleFocus = () => {
		setIsHoverActive(false);
	};

	const handleMouseLeave = () => {
		setIsHoverActive(true);
	};

	var countValue = 1;
	if ((window as any).IsSearchPage) countValue = 0;

	function outputName(displayValue: string) {
		var stringParts = displayValue.split("|");

		var dropdownDisplay = stringParts[0];

		if (dropdownDisplay.trim().startsWith("-")) {
			dropdownDisplay = dropdownDisplay.slice(1).trim();
		}

		return dropdownDisplay;
	}
	function success(position) {
		const latitude = position.coords.latitude;
		const longitude = position.coords.longitude;

		console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

		searchBoxController.updateText(
			currentLocText + ": " + latitude + " : " + longitude,
		);

		window.location.href =
			"/community-finder#mlat=" +
			latitude +
			"&mlng=" +
			longitude +
			"&mzml=10&mrad=60000";
	}

	function redirectToCommunity(url: string) {
		window.location.href = url;
	}

	function redirectToCommunityFinderAutoComplete(
		autoCompleteDisplayValue: string,
		autoCompleteRawValue: string,
	) {
		// if (isZipValid(autoCompleteRawValue)) {
		// 	var zipLocation = usZips[autoCompleteRawValue];

		// 	if (zipLocation) {
		// 		window.location.href =
		// 			"/community-finder#mlat=" +
		// 			zipLocation.latitude +
		// 			"&mlng=" +
		// 			zipLocation.longitude +
		// 			"&mzml=11&mrad=70000";
		// 	}
		// } else {
		//If the user clicks current location in the autocomplete drop down then redirect them to the
		// commnity finder page with the location data.
		if (
			autoCompleteDisplayValue.toLocaleLowerCase() ===
			currentLocText.toLocaleLowerCase()
		) {
			redirectToCommunityFinderCurrentLocation();
		}
		//Otherwise use the location url from the parsed auto complete field
		else {
			var autocomplete = parseAutocompleteFieldValue(autoCompleteDisplayValue);

			searchBoxController.updateText(autocomplete.text);

			window.location.href = autocomplete.url;
		}
		//}
	}

	function error(error) {
		console.log("Unable to retrieve your location");
	}

	function redirectToCommunityFinderCurrentLocation() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(success, error);
		} else {
			console.log("Geolocation not supported");
		}
	}

	function goToMapPage() {
		window.location.href = "/globalmap";
	}

	//Only add the class name to the form when being displayed on the homepage
	const formClassName = isHomepage
		? "search-form quick-search-wrapper"
		: "site-search";

	//Only show the list if there are suggestions, this stops an emtpy box from opening when you click on the textbox
	function setListOpen() {
		setOpen(suggestValues.length > 0);
	}

	const styles = {
		svg: {
			enableBackground: "new 0 0 22 22",
		},
		fill1: {
			fill: "#00205B",
		},
		fill2: {
			fill: "#fff",
		},
	};

	function getOptionClassName(result: FieldSuggestionsValue): string {
		let className = "option";

		if (
			result?.rawValue?.toLocaleLowerCase() ===
			currentLocText.toLocaleLowerCase()
		) {
			className += " current-location-option";
		}

		return className;
	}

	//Function for handling an enter being pressed in the main search box.  IF there are no suggestions it will take you to the
	// map page and if there are suggestions it will take you to the first result.
	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			let suggestedValue = false;

			//Check to see if the selected value matches a value in the displayed list
			//If so then go to that page let the browser do what it would normally do.
			//If not match is found that means we should goto the first option.
			fieldSuggestController.state.values.forEach((suggestValue) => {
				let autocompleteValue = parseAutocompleteFieldValue(
					suggestValue.rawValue,
				);

				if (
					autocompleteValue.text.trim().toLowerCase() ===
					event.currentTarget.value.trim().toLowerCase()
				) {
					suggestedValue = true;
				}
			});

			matchedValues.forEach((matchedValue) => {
				let matchedValueNoZip = stripZipCode(matchedValue.title);

				if (matchedValueNoZip === event.currentTarget.value) {
					suggestedValue = true;
				}
			});

			if (!suggestedValue) {
				event.preventDefault();
				//If there is zero suggested values that means there are no results (this is because we are adding current location manually as a suggested value)
				if (suggestValues.length == 0 && matchedValues.length == 0) {
				   goToMapPage();
				} else {
					//If the local results are shown then use the first one of those.
					if (matchedValues.length > 0) {
						window.location.href = matchedValues[0].url;
					} else {
						//If there are no local results then use the autocomplete list.
						//On the homepage the index is 1 due to the current location option being available.
						//On other pages it is 0 since there is no current location option.
						let valueIndex = 0;
						if (!(window as any).IsSearchPage) {
							valueIndex = 1;
						}

						let autocompleteValue = parseAutocompleteFieldValue(
							suggestValues[valueIndex].rawValue,
						);

						window.location.href = autocompleteValue.url;
					}
				}
			} else {
				//This captures the case where the user does not interact with the list
				// but types something that exactly matches an option in the list.
				let valueIndex = 0;
				if (!(window as any).IsSearchPage) {
					valueIndex = 1;
				}

				let autocompleteValue = parseAutocompleteFieldValue(
					suggestValues[valueIndex].rawValue,
				);

				if (
					autocompleteValue.text.trim().toLowerCase() ===
					event.currentTarget.value.trim().toLowerCase()
				) {
					event.preventDefault();
					window.location.href = autocompleteValue.url;
				}
			}
		}
	};

	return (
		<RadixPopover.Root open={open} onOpenChange={(e) => setListOpen()}>
			<ComboboxProvider open={open} setOpen={(e) => setListOpen()}>
				<form className={formClassName}>
					<RadixPopover.Anchor asChild>
						<Combobox
							ref={comboboxRef}
							placeholder="Search by zip, city, state, or community"
							onInput={(e) => onInput(e.currentTarget.value)}
							onFocus={(event) => onFocus(event.currentTarget.value)}
							aria-owns="listbox"
							type="text"
							onKeyDown={handleKeyDown}
						/>
					</RadixPopover.Anchor>
				</form>
				<RadixPopover.Content
					asChild
					sideOffset={8}
					onOpenAutoFocus={(event) => event.preventDefault()}
					className="search-frame-position"
					onInteractOutside={(event) => {
						const target = event.target as Element | null;

						const isCombobox = target === comboboxRef.current;
						const inListbox = target && listboxRef.current?.contains(target);

						event.preventDefault();

						//If the user interacts outside of the drop down close it
						if (!(isCombobox || inListbox)) {
							setOpen(false);
						}
					}}
				>
					{fieldSuggestController.state.query && (
						<ComboboxList
							ref={listboxRef}
							role="listbox"
							className="listbox"
							id="listbox"
						>
							{/* This is only used when the search box is at the top of the page, not on the homepage */}
							{showCurrent && <label>Current Results</label>}
							{matchedValues.map((result, count) => (
								<ComboboxItem
									focusOnHover
									className="option"
									value={stripZipCode(result.title)}
									onClick={() => redirectToCommunity(result.url)}
									key={result.url}
									{...(count === countValue && isHoverActive
										? { "data-active-item": "true" }
										: {})}
									onMouseEnter={handleMouseEnter}
									onMouseLeave={handleMouseLeave}
									onFocus={handleFocus}
								>
									{stripZipCode(result.title)}
								</ComboboxItem>
							))}
							{!isHomepage &&
								suggestValues.length > 0 &&
								(window as any).IsSearchPage && (
									<label>Search all of www.drhorton.com</label>
								)}
							{suggestValues.map((facetSearchValue, count) => (
								<ComboboxItem
									focusOnHover
									className={getOptionClassName(facetSearchValue)}
									value={outputName(facetSearchValue.displayValue)}
									onClick={() =>
										redirectToCommunityFinderAutoComplete(
											facetSearchValue.displayValue,
											facetSearchValue.rawValue,
										)
									}
									key={facetSearchValue.displayValue}
									{...(count === countValue &&
									isHoverActive &&
									matchedValues.length == 0
										? { "data-active-item": "true" }
										: {})}
									onMouseEnter={handleMouseEnter}
									onMouseLeave={handleMouseLeave}
									onFocus={handleFocus}
								>
									{outputName(facetSearchValue.displayValue)}
								</ComboboxItem>
							))}
							{suggestValues.length == 0 &&
								!fieldSuggestController.state.isLoading && (
									<div className="search-suggestions_container">
										<div className="search-suggestions">
											Sorry, no results for "
											{fieldSuggestController.state.query}"
										</div>
										<div className="search-suggestions_choices">
											<div className="search-suggestions_choice">
												{
													<svg
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 22 22"
														xmlSpace="preserve"
														onClick={() => goToMapPage()}
													>
														{" "}
														<path
															d="M21.1 1.1c-.2-.2-.5-.2-.8-.1l-6.1 1.8L8 1h-.5L1.2 2.8c-.4.1-.6.5-.6.8v16.5c0 .3.1.5.4.7.2.1.3.2.5.2h.2l6.1-1.8 6.1 1.8h.5l6.4-1.8c.4-.1.6-.5.6-.8V1.8c0-.3-.1-.5-.3-.7zM8.3 2.9l5.4 1.6v14.7l-5.4-1.6V2.9zm-6 1.4 5-1.5v14.7l-5 1.5V4.3zm17.4 13.4-5 1.4V4.4l5-1.4v14.7z"
															style={styles.fill1}
														></path>{" "}
													</svg>
												}
												<button
													className="search-suggestions_map"
													onClick={() => goToMapPage()}
												>
													Search by map
												</button>
											</div>
											<div className="search-suggestions_choice">
												{
													<svg
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 22 22"
														xmlSpace="preserve"
														onClick={() =>
															redirectToCommunityFinderCurrentLocation()
														}
													>
														{" "}
														<path
															d="M11 .9C7.1.9 4 4 4 7.9 4 13.2 11 21 11 21s7-7.8 7-13.1c0-3.8-3.1-7-7-7z"
															style={styles.fill1}
														></path>{" "}
														<path
															d="M11 11.1c-1.6 0-3.1-1.3-3.1-3S9.3 5 10.9 5 14 6.4 14 8s-1.4 2.9-3 3.1z"
															style={styles.fill2}
														></path>{" "}
													</svg>
												}
												<button
													className="search-suggestions_location"
													onClick={() =>
														redirectToCommunityFinderCurrentLocation()
													}
												>
													Search by current location
												</button>
											</div>
										</div>
									</div>
								)}
						</ComboboxList>
					)}
				</RadixPopover.Content>
			</ComboboxProvider>
		</RadixPopover.Root>
	);
};
